module.exports = __webpack_public_path__ + "static/media/locked.b0a4c9aa.png";